import { render, staticRenderFns } from "./BoxPerformanceComparisonRadarPeerGroup.vue?vue&type=template&id=f8fa8048&scoped=true&"
import script from "./BoxPerformanceComparisonRadarPeerGroup.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonRadarPeerGroup.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonRadarPeerGroup.vue?vue&type=style&index=0&id=f8fa8048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fa8048",
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
